import { db, docFromSnapshot } from "../firebase";

export const DEFAULT_SETTINGS = {
  company: {
    name: null,
    emailAddress: null,
    address: {
      line1: null,
      line2: null,
      district: null,
      region: null,
      country: null,
      postcode: null
    },
    bankDetails: {
      bankName: null,
      accountName: null,
      accountNumber: null,
      sortCode: null,
      bic: null,
      iban: null
    }
  },
  invoicing: {
    defaultVatRate: 23,
    defaultDaysToPay: 30
  },
  stripeUserId: null,
  customerStatements: {
    enabled: true
  },
  paymentReminders: {
    enabled: true
  }
};

const state = {
  userSettings: DEFAULT_SETTINGS
};

const getters = {
  userSettings: state => state.userSettings
};

const actions = {
  async fetchUserSettings(context) {
    const uid = context.rootGetters.tenantId;
    if (!uid) return;
    const snapshot = await db
      .collection("user-settings")
      .doc(uid)
      .get();
    const userSettings = docFromSnapshot(snapshot)? docFromSnapshot(snapshot): DEFAULT_SETTINGS ;
    context.commit("setUserSettings", userSettings);
  },
  async updateUserSettings(context, userSettings) {
    const uid = context.rootGetters.tenantId || context.rootGetters.userId;
    if (!uid) {
      throw new Error("Your book is still opening. Wait a moment and try again.");
    }
    userSettings.timestamp = +new Date();
    userSettings.tenantId = uid;
    await db
      .collection("user-settings")
      .doc(uid)
      .set(userSettings);
    context.commit("setUserSettings", userSettings);
  },
  async resetUserSettings(context, uid) {
    const userSettings = { ...DEFAULT_SETTINGS, timestamp: +new Date() };

    await db
      .collection("user-settings")
      .doc(uid)
      .set(userSettings);

    context.commit("setUserSettings", userSettings);
  }
};

const mutations = {
  setUserSettings(state, userSettings) {
    state.userSettings = userSettings;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
